/* ==========================================================================
   Gadea Loreak — Quick-add de la tarjeta de producto (iurop-product-card)
   --------------------------------------------------------------------------
   Añade la variante al carrito por AJAX (/cart/add.js) y avisa al side-cart
   para que se abra. Se carga UNA sola vez (bundle de Shopify) y usa delegación
   de eventos, así que sirve para todas las tarjetas de la página.

   CONTRATO con el side-cart (snippet iurop-cart-drawer, construido aparte):
   tras añadir, se despachan sobre `document`:
     • 'cart:updated'      detail: { cart, source: 'iurop-product-card' }
     • 'cart-drawer:open'  detail: { cart }
   El side-cart debe escuchar 'cart:updated' para refrescar su contenido y
   'cart-drawer:open' para mostrarse. Si el drawer expone
   window.iuropCartDrawer.open(cart), también se invoca.
   ========================================================================== */
(function () {
  if (window.__iuropProductCardInit) return;
  window.__iuropProductCardInit = true;

  var SELECTOR = '[data-iurop-quick-add]';

  function getRoutes() {
    var r = (window.Shopify && window.Shopify.routes) || {};
    return {
      add: (r.root || '/') + 'cart/add.js',
      cart: (r.root || '/') + 'cart.js',
    };
  }

  function openDrawer(cart) {
    // 1) API directa si el drawer la expone.
    if (window.iuropCartDrawer && typeof window.iuropCartDrawer.open === 'function') {
      window.iuropCartDrawer.open(cart);
      return;
    }
    // 2) Eventos que el side-cart puede escuchar.
    document.dispatchEvent(new CustomEvent('cart-drawer:open', { detail: { cart: cart } }));
  }

  function notifyUpdated(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:updated', { detail: { cart: cart, source: 'iurop-product-card' } })
    );
  }

  function setLoading(btn, loading) {
    btn.classList.toggle('is-loading', loading);
    if (loading) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }

  function flashState(btn, cls) {
    btn.classList.add(cls);
    window.setTimeout(function () {
      btn.classList.remove(cls);
    }, 1400);
  }

  function quickAdd(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    var routes = getRoutes();
    setLoading(btn, true);

    fetch(routes.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      })
      .then(function () {
        return fetch(routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        notifyUpdated(cart);
        openDrawer(cart);
        flashState(btn, 'is-added');
      })
      .catch(function (err) {
        // eslint-disable-next-line no-console
        console.warn('[iurop-product-card] No se pudo añadir al carrito:', err);
        flashState(btn, 'is-error');
      })
      .finally(function () {
        setLoading(btn, false);
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!btn) return;
    event.preventDefault();
    quickAdd(btn);
  });
})();
